__turbopack_context__.v({
  "contact": "footer-module-scss-module__y-VvPW__contact",
  "contactBox": "footer-module-scss-module__y-VvPW__contactBox",
  "contactSponsored": "footer-module-scss-module__y-VvPW__contactSponsored",
  "contactsection": "footer-module-scss-module__y-VvPW__contactsection",
  "container": "footer-module-scss-module__y-VvPW__container",
  "copyright": "footer-module-scss-module__y-VvPW__copyright",
  "emailError": "footer-module-scss-module__y-VvPW__emailError",
  "errorMessage": "footer-module-scss-module__y-VvPW__errorMessage",
  "footerBottomSection": "footer-module-scss-module__y-VvPW__footerBottomSection",
  "footerlast": "footer-module-scss-module__y-VvPW__footerlast",
  "footermiddle": "footer-module-scss-module__y-VvPW__footermiddle",
  "form": "footer-module-scss-module__y-VvPW__form",
  "heading": "footer-module-scss-module__y-VvPW__heading",
  "logo": "footer-module-scss-module__y-VvPW__logo",
  "message": "footer-module-scss-module__y-VvPW__message",
  "newsletterBox": "footer-module-scss-module__y-VvPW__newsletterBox",
  "newsletterButton": "footer-module-scss-module__y-VvPW__newsletterButton",
  "newsletterInput": "footer-module-scss-module__y-VvPW__newsletterInput",
  "newslettertext": "footer-module-scss-module__y-VvPW__newslettertext",
  "noMargin": "footer-module-scss-module__y-VvPW__noMargin",
  "root": "footer-module-scss-module__y-VvPW__root",
  "subHeading": "footer-module-scss-module__y-VvPW__subHeading",
});
